import { trpcSlice as api } from "./src/trpcSlice";
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    ping: build.query<PingApiResponse, PingApiArg>({
      query: () => ({ url: `/trpcping` }),
    }),
    getProjectMembers: build.query<GetProjectMembersApiResponse, GetProjectMembersApiArg>({
      query: (queryArg) => ({
        url: `/project/members`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    putProjectMember: build.mutation<PutProjectMemberApiResponse, PutProjectMemberApiArg>({
      query: (queryArg) => ({ url: `/project/member`, method: "PUT", body: queryArg.body }),
    }),
    getProjectMember: build.query<GetProjectMemberApiResponse, GetProjectMemberApiArg>({
      query: (queryArg) => ({
        url: `/project/member`,
        params: {
          projectId: queryArg.projectId,
          memberId: queryArg.memberId,
        },
      }),
    }),
    putProjectMemberOtherAttributes: build.mutation<
      PutProjectMemberOtherAttributesApiResponse,
      PutProjectMemberOtherAttributesApiArg
    >({
      query: (queryArg) => ({ url: `/project/member/other-attributes`, method: "PUT", body: queryArg.body }),
    }),
    getProjectIssueboards: build.query<GetProjectIssueboardsApiResponse, GetProjectIssueboardsApiArg>({
      query: (queryArg) => ({
        url: `/project/issueboards`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectPns: build.query<GetProjectPnsApiResponse, GetProjectPnsApiArg>({
      query: (queryArg) => ({
        url: `/project/pns`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getProjectProjectId: build.query<GetProjectProjectIdApiResponse, GetProjectProjectIdApiArg>({
      query: (queryArg) => ({
        url: `/project/project-id`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getProjectsMcapps: build.query<GetProjectsMcappsApiResponse, GetProjectsMcappsApiArg>({
      query: () => ({ url: `/projects/mcapps` }),
    }),
    getProjectsMaconomy: build.query<GetProjectsMaconomyApiResponse, GetProjectsMaconomyApiArg>({
      query: () => ({ url: `/projects/maconomy` }),
    }),
    postProjectByProjectIdReportboards: build.mutation<
      PostProjectByProjectIdReportboardsApiResponse,
      PostProjectByProjectIdReportboardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/reportboards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putUserProfile: build.mutation<PutUserProfileApiResponse, PutUserProfileApiArg>({
      query: (queryArg) => ({ url: `/user/profile`, method: "PUT", body: queryArg.body }),
    }),
    getWhoami: build.query<GetWhoamiApiResponse, GetWhoamiApiArg>({
      query: () => ({ url: `/whoami` }),
    }),
    postUserApikey: build.mutation<PostUserApikeyApiResponse, PostUserApikeyApiArg>({
      query: (queryArg) => ({ url: `/user/apikey`, method: "POST", body: queryArg.body }),
    }),
    getUserApikey: build.query<GetUserApikeyApiResponse, GetUserApikeyApiArg>({
      query: () => ({ url: `/user/apikey` }),
    }),
    deleteUserApikey: build.mutation<DeleteUserApikeyApiResponse, DeleteUserApikeyApiArg>({
      query: () => ({ url: `/user/apikey`, method: "DELETE" }),
    }),
    getChecklistMcTemplates: build.query<GetChecklistMcTemplatesApiResponse, GetChecklistMcTemplatesApiArg>({
      query: (queryArg) => ({
        url: `/checklist/mc-templates`,
        params: {
          showInDevelopment: queryArg.showInDevelopment,
        },
      }),
    }),
    postChecklistMcTemplates: build.mutation<PostChecklistMcTemplatesApiResponse, PostChecklistMcTemplatesApiArg>({
      query: (queryArg) => ({ url: `/checklist/mc-templates`, method: "POST", body: queryArg.body }),
    }),
    postChecklistGenerateDocx: build.mutation<PostChecklistGenerateDocxApiResponse, PostChecklistGenerateDocxApiArg>({
      query: (queryArg) => ({ url: `/checklist/generate-docx`, method: "POST", body: queryArg.body }),
    }),
    getChecklistByChecklistIdExport: build.query<
      GetChecklistByChecklistIdExportApiResponse,
      GetChecklistByChecklistIdExportApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/${queryArg.checklistId}/export`,
        params: {
          excel: queryArg.excel,
        },
      }),
    }),
    postChecklistValidateExcel: build.mutation<PostChecklistValidateExcelApiResponse, PostChecklistValidateExcelApiArg>(
      {
        query: (queryArg) => ({ url: `/checklist/validate-excel`, method: "POST", body: queryArg.body }),
      },
    ),
    postChecklistMcTemplatesPublish: build.mutation<
      PostChecklistMcTemplatesPublishApiResponse,
      PostChecklistMcTemplatesPublishApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/mc-templates/publish`, method: "POST", body: queryArg.body }),
    }),
    getChecklistLogs: build.query<GetChecklistLogsApiResponse, GetChecklistLogsApiArg>({
      query: (queryArg) => ({
        url: `/checklist/logs`,
        params: {
          projectNo: queryArg.projectNo,
          checklistId: queryArg.checklistId,
        },
      }),
    }),
    getChecklistProjectTemplates: build.query<
      GetChecklistProjectTemplatesApiResponse,
      GetChecklistProjectTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/project-templates`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    postChecklistMcTemplatesUploadDocx: build.mutation<
      PostChecklistMcTemplatesUploadDocxApiResponse,
      PostChecklistMcTemplatesUploadDocxApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/mc-templates/upload-docx`, method: "POST", body: queryArg.body }),
    }),
    getChecklistMcTemplatesDocxDownload: build.query<
      GetChecklistMcTemplatesDocxDownloadApiResponse,
      GetChecklistMcTemplatesDocxDownloadApiArg
    >({
      query: (queryArg) => ({
        url: `/checklist/mc-templates/docx/download`,
        params: {
          filename: queryArg.filename,
        },
      }),
    }),
    getChecklistMcTemplatesDocx: build.query<GetChecklistMcTemplatesDocxApiResponse, GetChecklistMcTemplatesDocxApiArg>(
      {
        query: () => ({ url: `/checklist/mc-templates/docx` }),
      },
    ),
    postChecklistGenerateDocxAzure: build.mutation<
      PostChecklistGenerateDocxAzureApiResponse,
      PostChecklistGenerateDocxAzureApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/generate-docx-azure`, method: "POST", body: queryArg.body }),
    }),
    postChecklistIntegrationGenerate: build.mutation<
      PostChecklistIntegrationGenerateApiResponse,
      PostChecklistIntegrationGenerateApiArg
    >({
      query: (queryArg) => ({ url: `/checklist/integration/generate`, method: "POST", body: queryArg.body }),
    }),
    getChecklistsByReviewByReviewId: build.query<
      GetChecklistsByReviewByReviewIdApiResponse,
      GetChecklistsByReviewByReviewIdApiArg
    >({
      query: (queryArg) => ({ url: `/checklists/by-review/${queryArg.reviewId}` }),
    }),
    putChecklistsByChecklistIdDkApprovalToggle: build.mutation<
      PutChecklistsByChecklistIdDkApprovalToggleApiResponse,
      PutChecklistsByChecklistIdDkApprovalToggleApiArg
    >({
      query: (queryArg) => ({
        url: `/checklists/${queryArg.checklistId}/dk-approval/toggle`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssuesCreate: build.mutation<
      PostProjectByProjectIdIssuesCreateApiResponse,
      PostProjectByProjectIdIssuesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/create`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssuesTrpcIssueGetConnectedIssues: build.query<
      GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiResponse,
      GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/trpcIssueGetConnectedIssues`,
        params: {
          _id: queryArg._id,
        },
      }),
    }),
    putProjectByProjectIdIssuesUpdateGantActivity: build.mutation<
      PutProjectByProjectIdIssuesUpdateGantActivityApiResponse,
      PutProjectByProjectIdIssuesUpdateGantActivityApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/update-gant-activity`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putIssueConnect: build.mutation<PutIssueConnectApiResponse, PutIssueConnectApiArg>({
      query: (queryArg) => ({ url: `/issue/connect`, method: "PUT", body: queryArg.body }),
    }),
    getIssueByUser: build.query<GetIssueByUserApiResponse, GetIssueByUserApiArg>({
      query: (queryArg) => ({
        url: `/issue/by-user`,
        params: {
          relation: queryArg.relation,
          maxAgeYears: queryArg.maxAgeYears,
          projectId: queryArg.projectId,
        },
      }),
    }),
    putProjectByProjectIdIssuesKanbanreorder: build.mutation<
      PutProjectByProjectIdIssuesKanbanreorderApiResponse,
      PutProjectByProjectIdIssuesKanbanreorderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/kanbanreorder`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoards: build.query<
      GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiResponse,
      GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/by-connectedTasksAndIssuesFromOtherBoards`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    postProjectByProjectIdIssuesCopy: build.mutation<
      PostProjectByProjectIdIssuesCopyApiResponse,
      PostProjectByProjectIdIssuesCopyApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issues/copy`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdIssuesGetSingle: build.query<
      GetProjectByProjectIdIssuesGetSingleApiResponse,
      GetProjectByProjectIdIssuesGetSingleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/get-single`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    getProjectByProjectIdIssuesExternal: build.query<
      GetProjectByProjectIdIssuesExternalApiResponse,
      GetProjectByProjectIdIssuesExternalApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/external`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeTasks: queryArg.includeTasks,
        },
      }),
    }),
    getProjectByProjectIdIssuesOnBoard: build.query<
      GetProjectByProjectIdIssuesOnBoardApiResponse,
      GetProjectByProjectIdIssuesOnBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-board`,
        params: {
          issueboardId: queryArg.issueboardId,
          includeIssues: queryArg.includeIssues,
          includeTasks: queryArg.includeTasks,
          taskOrIssue: queryArg.taskOrIssue,
        },
      }),
    }),
    postProjectByProjectIdIssuesOnBoards: build.mutation<
      PostProjectByProjectIdIssuesOnBoardsApiResponse,
      PostProjectByProjectIdIssuesOnBoardsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues-on-boards`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateDates: build.mutation<
      PutProjectByProjectIdIssueUpdateDatesApiResponse,
      PutProjectByProjectIdIssueUpdateDatesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-dates`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueConnectedBimSpaces: build.mutation<
      PutProjectByProjectIdIssueConnectedBimSpacesApiResponse,
      PutProjectByProjectIdIssueConnectedBimSpacesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/connected-bim-spaces`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdConnectedTasks: build.query<
      GetProjectByProjectIdConnectedTasksApiResponse,
      GetProjectByProjectIdConnectedTasksApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/connected-tasks`,
        params: {
          issueId: queryArg.issueId,
        },
      }),
    }),
    postProjectByProjectIdIssueTodosAdd: build.mutation<
      PostProjectByProjectIdIssueTodosAddApiResponse,
      PostProjectByProjectIdIssueTodosAddApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/add`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueTodosUpdate: build.mutation<
      PutProjectByProjectIdIssueTodosUpdateApiResponse,
      PutProjectByProjectIdIssueTodosUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/update`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueTodosToggle: build.mutation<
      PutProjectByProjectIdIssueTodosToggleApiResponse,
      PutProjectByProjectIdIssueTodosToggleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/toggle`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    deleteProjectByProjectIdIssueTodosDelete: build.mutation<
      DeleteProjectByProjectIdIssueTodosDeleteApiResponse,
      DeleteProjectByProjectIdIssueTodosDeleteApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/todos/delete`,
        method: "DELETE",
        params: {
          issueId: queryArg.issueId,
          todoId: queryArg.todoId,
        },
      }),
    }),
    postProjectByProjectIdIssuesGenerateDocx: build.mutation<
      PostProjectByProjectIdIssuesGenerateDocxApiResponse,
      PostProjectByProjectIdIssuesGenerateDocxApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/generate-docx`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateSimple: build.mutation<
      PutProjectByProjectIdIssueUpdateSimpleApiResponse,
      PutProjectByProjectIdIssueUpdateSimpleApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-simple`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueUpdateUser: build.mutation<
      PutProjectByProjectIdIssueUpdateUserApiResponse,
      PutProjectByProjectIdIssueUpdateUserApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/update-user`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueConnectedTasksUpdateOrder: build.mutation<
      PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiResponse,
      PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/connected-tasks/update-order`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueSubscribe: build.mutation<
      PutProjectByProjectIdIssueSubscribeApiResponse,
      PutProjectByProjectIdIssueSubscribeApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/subscribe`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdIssueArchive: build.mutation<
      PutProjectByProjectIdIssueArchiveApiResponse,
      PutProjectByProjectIdIssueArchiveApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue/archive`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueAndIssueIdLogs: build.query<
      GetProjectByProjectIdIssueAndIssueIdLogsApiResponse,
      GetProjectByProjectIdIssueAndIssueIdLogsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/issue/${queryArg.issueId}/logs` }),
    }),
    getProjectByProjectIdIssuesValidateOtherAttributesByBoard: build.query<
      GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiResponse,
      GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/validate-other-attributes-by-board`,
        params: {
          issueBoardId: queryArg.issueBoardId,
        },
      }),
    }),
    postProjectByProjectIdIssuesAndIssueIdRunBreeamCheck: build.mutation<
      PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiResponse,
      PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issues/${queryArg.issueId}/run-breeam-check`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getUsageAggregateProjectStarts: build.query<
      GetUsageAggregateProjectStartsApiResponse,
      GetUsageAggregateProjectStartsApiArg
    >({
      query: (queryArg) => ({
        url: `/usage/aggregate/project-starts`,
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
          appName: queryArg.appName,
        },
      }),
    }),
    getUsageAggregateProject: build.query<GetUsageAggregateProjectApiResponse, GetUsageAggregateProjectApiArg>({
      query: (queryArg) => ({
        url: `/usage/aggregate/project`,
        params: {
          fromDate: queryArg.fromDate,
          toDate: queryArg.toDate,
          projectId: queryArg.projectId,
        },
      }),
    }),
    getProjectByProjectIdTableTemplates: build.query<
      GetProjectByProjectIdTableTemplatesApiResponse,
      GetProjectByProjectIdTableTemplatesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-templates`,
        params: {
          issueboardId: queryArg.issueboardId,
        },
      }),
    }),
    patchProjectByProjectIdTableTemplate: build.mutation<
      PatchProjectByProjectIdTableTemplateApiResponse,
      PatchProjectByProjectIdTableTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-template`,
        method: "PATCH",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdTableTemplate: build.mutation<
      PostProjectByProjectIdTableTemplateApiResponse,
      PostProjectByProjectIdTableTemplateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/table-template`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdAgendaItemReorderConnectedIssues: build.mutation<
      PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiResponse,
      PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/agendaItem/reorder-connected-issues`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postIssueboardFavoriteToggle: build.mutation<
      PostIssueboardFavoriteToggleApiResponse,
      PostIssueboardFavoriteToggleApiArg
    >({
      query: (queryArg) => ({ url: `/issueboard/favorite/toggle`, method: "POST", body: queryArg.body }),
    }),
    getIssueboardFavorites: build.query<GetIssueboardFavoritesApiResponse, GetIssueboardFavoritesApiArg>({
      query: (queryArg) => ({
        url: `/issueboard/favorites`,
        params: {
          projectId: queryArg.projectId,
        },
      }),
    }),
    putProjectByProjectIdGanttVacations: build.mutation<
      PutProjectByProjectIdGanttVacationsApiResponse,
      PutProjectByProjectIdGanttVacationsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/gantt-vacations`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    patchBoardsTemplateAction: build.mutation<PatchBoardsTemplateActionApiResponse, PatchBoardsTemplateActionApiArg>({
      query: (queryArg) => ({ url: `/boards/template/action`, method: "PATCH", body: queryArg.body }),
    }),
    postProjectByProjectIdIssueboardPredefinedtagsUpdate: build.mutation<
      PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiResponse,
      PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/predefinedtags.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdIssueboardUsepredefinedtagsUpdate: build.mutation<
      PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiResponse,
      PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issueboard/usepredefinedtags.update`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    getProjectByProjectIdIssueLogs: build.query<
      GetProjectByProjectIdIssueLogsApiResponse,
      GetProjectByProjectIdIssueLogsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/issue-logs`,
        params: {
          boardId: queryArg.boardId,
          createdAtFrom: queryArg.createdAtFrom,
          createdAtTo: queryArg.createdAtTo,
          limit: queryArg.limit,
          page: queryArg.page,
          includeTotalCount: queryArg.includeTotalCount,
        },
      }),
    }),
    getMcbimFurnitureAndWallsOnFloor: build.query<
      GetMcbimFurnitureAndWallsOnFloorApiResponse,
      GetMcbimFurnitureAndWallsOnFloorApiArg
    >({
      query: (queryArg) => ({
        url: `/mcbim/furniture-and-walls-on-floor`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    getMcbimSpaces: build.query<GetMcbimSpacesApiResponse, GetMcbimSpacesApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/spaces`,
        params: {
          projectNo: queryArg.projectNo,
        },
      }),
    }),
    getMcbimSpacesOnFloor: build.query<GetMcbimSpacesOnFloorApiResponse, GetMcbimSpacesOnFloorApiArg>({
      query: (queryArg) => ({
        url: `/mcbim/spaces-on-floor`,
        params: {
          projectNo: queryArg.projectNo,
          floorName: queryArg.floorName,
        },
      }),
    }),
    getEmailsTemplates: build.query<GetEmailsTemplatesApiResponse, GetEmailsTemplatesApiArg>({
      query: () => ({ url: `/emails/templates` }),
    }),
    getEmailsTemplatesDownload: build.query<GetEmailsTemplatesDownloadApiResponse, GetEmailsTemplatesDownloadApiArg>({
      query: (queryArg) => ({
        url: `/emails/templates/download`,
        params: {
          templateKey: queryArg.templateKey,
        },
      }),
    }),
    postEmailsTemplatesUploadZip: build.mutation<
      PostEmailsTemplatesUploadZipApiResponse,
      PostEmailsTemplatesUploadZipApiArg
    >({
      query: (queryArg) => ({ url: `/emails/templates/upload-zip`, method: "POST", body: queryArg.body }),
    }),
    getProjectByProjectIdProjectdashboardAndDashboardIdNews: build.query<
      GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse,
      GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiArg
    >({
      query: (queryArg) => ({ url: `/project/${queryArg.projectId}/projectdashboard/${queryArg.dashboardId}/news` }),
    }),
    postProjectByProjectIdProjectdashboardNews: build.mutation<
      PostProjectByProjectIdProjectdashboardNewsApiResponse,
      PostProjectByProjectIdProjectdashboardNewsApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    putProjectByProjectIdProjectdashboardNewsAndNewsItemId: build.mutation<
      PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiResponse,
      PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news/${queryArg.newsItemId}`,
        method: "PUT",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReaction: build.mutation<
      PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiResponse,
      PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/${queryArg.dashboardId}/news/comment/reaction`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
    postProjectByProjectIdProjectdashboardNewsSearch: build.mutation<
      PostProjectByProjectIdProjectdashboardNewsSearchApiResponse,
      PostProjectByProjectIdProjectdashboardNewsSearchApiArg
    >({
      query: (queryArg) => ({
        url: `/project/${queryArg.projectId}/projectdashboard/news/search`,
        method: "POST",
        body: queryArg.body,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as openapi };
export type PingApiResponse = /** status 200 Successful response */ {
  ping: string;
};
export type PingApiArg = void;
export type GetProjectMembersApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
}[];
export type GetProjectMembersApiArg = {
  projectId: string;
};
export type PutProjectMemberApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type PutProjectMemberApiArg = {
  body: {
    projectId: string;
    attribute: "disciplin" | "group" | "isPassive";
    value: string | boolean;
    memberId: string;
  };
};
export type GetProjectMemberApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type GetProjectMemberApiArg = {
  projectId: string;
  memberId: string;
};
export type PutProjectMemberOtherAttributesApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: {
    _id: string;
    name: string;
    email: string;
    fullEmail: string;
    phoneNumber: string | null;
    location: string | null;
    domain: string;
  };
  group: "ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT";
  isPassive: boolean;
  disciplin: string | null;
  memberOtherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
};
export type PutProjectMemberOtherAttributesApiArg = {
  body: {
    projectId: string;
    memberId: string;
    key: string;
    value: string | number | boolean | null | string[];
  };
};
export type GetProjectIssueboardsApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project: string;
  name: string;
  access: {
    /** AccessLevels */
    level: "PROJECT" | "USERS" | "GROUPS";
    groups: ("ADMIN" | "INTERNAL" | "PARTNER" | "CLIENT")[];
    users: {
      _id: string;
      name: string;
    }[];
  };
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "DELETED" | "INACTIVE";
  lastUpdatedBy?: {
    _id: string;
    name: string;
  };
  createdFromTemplate?: string;
  progress?: {
    percentage: number;
    color: string;
  }[];
  pns?: string;
  createdDate?: string;
  disabledColumns?: string[];
  disabledColumnsTasks?: string[];
  tableTemplates: {
    _id: string;
    name: string;
    issueBoard: string;
    tableColumns: string[];
    tableColConfigs?: {
      colId?: string;
      orderPriority?: number;
      width?: number;
    }[];
    taskAndOrIssue?: ("TASK" | "ISSUE")[];
    filters: {
      typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
      dataField?: string;
      multiFilterValues?: string[] | object[];
      isActive?: boolean;
    }[];
    sortedCol?: {
      column?: string;
      direction?: "ASC" | "DESC";
    };
    archived?: boolean;
  }[];
  buckets?: {
    _id?: string;
    value: string;
    order: number;
    status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  types?: {
    _id?: string;
    name: string;
  }[];
  useBucketsAsWorkflow?: boolean;
  allFilters: {
    dataField: string;
    options: {
      value: string;
      label: string;
      isActive: boolean;
    }[];
    bool?: boolean;
  }[];
  showConclusion: boolean;
  template?: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status: "CREATED" | "SET_TO_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history: {
      action: "CREATED" | "SET_TO_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
  defaultView?: "TABLE" | "GIS" | "KANBAN" | "NOTEBOARD" | "DASHBOARD" | "PNS" | "GANTT" | "BIM" | "NONE";
  defaultTemplate?: string;
  issueNameSetting?: string;
  taskNameSetting?: string;
  dashboardSetting?: string;
  category?: string;
  description?: string;
  bucketNameSetting?: string;
  showCompletedTodosInKanban?: boolean;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
  predefinedTags?: {
    _id?: string;
    title: string;
  }[];
  madeFromTemplate?: {
    title: string;
    id: string;
  };
  noteboardImageNodes?: {
    _id?: string;
    path: string;
    x: number;
    y: number;
    height: number;
    width: number;
  }[];
  createdBy: {
    _id: string;
    name: string;
  };
  otherAttributesTasksConfig?: {
    [key: string]: {
      typeOfValue:
        | "STRING"
        | "MULTILINESTRING"
        | "NUMBER"
        | "DATE"
        | "BOOLEAN"
        | "DROPDOWN"
        | "FORMULA"
        | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  otherAttributesConfig?: {
    [key: string]: {
      typeOfValue:
        | "STRING"
        | "MULTILINESTRING"
        | "NUMBER"
        | "DATE"
        | "BOOLEAN"
        | "DROPDOWN"
        | "FORMULA"
        | "MATH_FORMULA";
      dropdownOptionType?: "STRING" | "NUMBER";
      tableOptions?: {
        _id?: string;
        value: string | number;
        description: string | null;
        color?: string;
      }[];
      allowMultipleSelectionsInDropdown?: boolean;
      label: string;
      labelColor?: string;
      section: string;
      description: string;
      order: number;
      isActive: boolean;
      formula?: {
        nrOfCharsInCounter?: number;
        deletePreviousDelimiterIfAttributeIsEmpty?: boolean;
        confArr: {
          id?: string;
          type: "DELIMITER" | "ATTRIBUTE" | "COUNTER";
          value: string;
        }[];
      };
      mathFormula?: {
        expression?: string;
        variables?: string[];
      };
      locked?: boolean;
    };
  };
  risikoSection?: {
    isActive: boolean;
    enableProbabilityAfterTiltak: boolean;
    probabilites: {
      [key: string]: {
        id: string;
        name: string;
        description: string;
        matrixValue: number;
        isActive: boolean;
        order: number;
      };
    };
    evaluationCategoriesConfig: {
      [key: string]: {
        name: string;
        description: string;
        isActive: boolean;
        type: "RISK" | "OPPORTUNITY";
        matrixConfig: {
          color: string;
        }[][];
        consequences: {
          [key: string]: {
            id?: string;
            name: string;
            description: string | null;
            matrixValue: number;
            isActive: boolean;
            order: number;
          };
        };
      };
    };
  };
  ganttVacationSettings?: {
    startDate: string;
    endDate: string;
    title: string;
  }[];
  disableDeleteIssue?: boolean;
}[];
export type GetProjectIssueboardsApiArg = {
  projectId: string;
};
export type GetProjectPnsApiResponse = /** status 200 Successful response */ {
  _id: string;
  parentId: string | null;
  props: {
    pnsId: string;
    title: string;
  };
}[];
export type GetProjectPnsApiArg = {
  projectNo: number;
};
export type GetProjectProjectIdApiResponse = /** status 200 Successful response */ string;
export type GetProjectProjectIdApiArg = {
  projectNo: number;
};
export type GetProjectsMcappsApiResponse = /** status 200 Successful response */ {
  createdAt?: string;
  maconomy?: {
    projectNo: number;
    name: string;
    coordinates?: {
      UTMN: number;
      GNR: number;
      BNR: number;
      UTME: number;
      UTMZ: number;
    };
    useDashboardAsDefaultStartPage?: boolean;
  };
  _id: string;
}[];
export type GetProjectsMcappsApiArg = void;
export type GetProjectsMaconomyApiResponse = /** status 200 Successful response */ {
  projectNo: number;
  name: string;
  coordinates?: {
    UTMN: number;
    GNR: number;
    BNR: number;
    UTME: number;
    UTMZ: number;
  };
  useDashboardAsDefaultStartPage?: boolean;
}[];
export type GetProjectsMaconomyApiArg = void;
export type PostProjectByProjectIdReportboardsApiResponse = /** status 200 Successful response */ {
  _id?: string;
  project: string;
  name: string;
  createdBy?: string;
  status: "ACTIVE" | "DELETED" | "COMPLETED";
  versions: {
    versionNumber: number;
    savedBy: string;
    data: {
      [key: string]: any;
    };
    message?: string;
    createdAt: string;
  }[];
  lastUpdatedBy?: string;
  template: 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 601 | 701 | 901;
  doksam?: {
    subTaskNo?: string | null;
  };
  uploadedFiles?: {
    createdDate?: string;
    createdBy: string;
    height?: number;
    width?: number;
    filename: string;
    docxImageTag?: string;
  }[];
  createdAt?: string;
  updatedAt?: string;
};
export type PostProjectByProjectIdReportboardsApiArg = {
  projectId: string;
  body: {
    name: string;
    template: 101 | 102 | 103 | 104 | 106 | 201 | 202 | 205 | 301 | 401 | 601 | 701 | 901;
    doksam?: {
      subTaskNo?: string | null;
    };
  };
};
export type PutUserProfileApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  phoneNumber: string;
  location: string;
};
export type PutUserProfileApiArg = {
  body: {
    userId: string | any;
    patch: {
      name?: string;
      location?: string;
      phoneNumber?: string;
    };
  };
};
export type GetWhoamiApiResponse = /** status 200 Successful response */ {
  authType: "session" | "apiKey";
  user: {
    _id: string;
    name: string;
    email: string;
    phoneNumber: string;
    location: string;
  };
};
export type GetWhoamiApiArg = void;
export type PostUserApikeyApiResponse = /** status 200 Successful response */ {
  apiKey: string;
  prefix?: string | null;
};
export type PostUserApikeyApiArg = {
  body: object;
};
export type GetUserApikeyApiResponse = /** status 200 Successful response */ {
  prefix?: string | null;
  lastUsedAt: string | null;
  useCount: number;
  revokedAt: string | null;
} | null;
export type GetUserApikeyApiArg = void;
export type DeleteUserApikeyApiResponse = /** status 200 Successful response */ {
  ok: true;
};
export type DeleteUserApikeyApiArg = void;
export type GetChecklistMcTemplatesApiResponse = /** status 200 Successful response */ {
  id: number;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  name: string;
  disciplineCode: string;
  templateDescription: string;
  documentCategoryCode2: string;
  subDiscipline: string;
  competenceNetwork: string;
}[];
export type GetChecklistMcTemplatesApiArg = {
  showInDevelopment?: boolean;
};
export type PostChecklistMcTemplatesApiResponse = /** status 200 Successful response */ {
  checklistId: number;
  status: "IN_DEVELOPMENT";
  name: string;
  items: {
    id: string;
    title: string;
    reference: string;
    tags: string;
  }[];
  excel: {
    filename: string;
    contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    base64: string;
  };
};
export type PostChecklistMcTemplatesApiArg = {
  body: {
    title: string;
  };
};
export type PostChecklistGenerateDocxApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostChecklistGenerateDocxApiArg = {
  body: {
    data?: any;
    templateName: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
    outputName?: string;
  };
};
export type GetChecklistByChecklistIdExportApiResponse = /** status 200 Successful response */ {
  id: number;
  name: string;
  disciplineCode?: string;
  templateDescription?: string;
  documentCategoryCode2?: string;
  subDiscipline?: string;
  competenceNetwork?: string;
  documentManagers?: {
    preparedBy?: string;
    checkedBy?: string;
    approvedBy?: string;
  };
  admin?: string;
  disciplineLeader?: string;
  items: {
    id: string;
    title: string;
    reference: string;
    tags: string;
  }[];
  excel?: {
    filename: string;
    contentType: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    base64: string;
  };
};
export type GetChecklistByChecklistIdExportApiArg = {
  checklistId: number;
  excel?: boolean;
};
export type PostChecklistValidateExcelApiResponse = /** status 200 Successful response */
  | {
      isValid: boolean | null;
      value: string | number;
      col: number;
      row: number;
      reference?: string;
      itemTags?: string;
    }[][]
  | {
      status: "error";
      message: string;
      errors: {
        row: number;
        col: number;
        value: string | number;
        message: string;
      }[];
    };
export type PostChecklistValidateExcelApiArg = {
  body: {
    file: string;
  };
};
export type PostChecklistMcTemplatesPublishApiResponse = /** status 200 Successful response */
  | {
      status: "error";
      message: string;
      errors: {
        row: number;
        col: number;
        value: string | number;
        message: string;
      }[];
    }
  | {
      status: "success";
      message: string;
      data?: {
        isValid: boolean | null;
        value: string | number;
        col: number;
        row: number;
        reference?: string;
        itemTags?: string;
      }[][];
    }
  | {
      status: "dry-run";
      message: string;
      data?: {
        isValid: boolean | null;
        value: string | number;
        col: number;
        row: number;
        reference?: string;
        itemTags?: string;
      }[][];
    };
export type PostChecklistMcTemplatesPublishApiArg = {
  body: {
    checklistNrId: number;
    file: string;
    dryRun?: boolean;
    metadata: {
      name: string;
      status: "ACTIVE" | "IN_DEVELOPMENT" | "REMOVED";
      disciplineCode?: string | null;
      templateDescription?: string | null;
      subDiscipline?: string | null;
      competenceNetwork?: string | null;
      documentManagers?: {
        preparedBy?: string | null;
        checkedBy?: string | null;
        approvedBy?: string | null;
      };
      disciplineLeader?: string | null;
    };
  };
};
export type GetChecklistLogsApiResponse = /** status 200 Successful response */ {
  _id: string;
  project: string;
  board: string;
  rowId?: {
    _id: string;
    itemId: number;
    title: string;
  } | null;
  column: string;
  oldValue?: string | null;
  newValue?: string | null;
  user: {
    _id: string;
    name: string;
  };
  createdAt: string;
  updatedAt?: string | null;
}[];
export type GetChecklistLogsApiArg = {
  projectNo: number;
  checklistId: number;
};
export type GetChecklistProjectTemplatesApiResponse = /** status 200 Successful response */ {
  id: number;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  name: string;
  disciplineCode: string;
  templateDescription: string;
  documentCategoryCode2: string;
  subDiscipline: string;
  competenceNetwork: string;
}[];
export type GetChecklistProjectTemplatesApiArg = {
  projectNo: string;
};
export type PostChecklistMcTemplatesUploadDocxApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  blobName: string;
  etag?: string;
};
export type PostChecklistMcTemplatesUploadDocxApiArg = {
  body: {
    file: {
      filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
      contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
      base64: string;
    };
  };
};
export type GetChecklistMcTemplatesDocxDownloadApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
  contentType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document";
  base64: string;
  sizeBytes: number;
  etag: string | null;
  lastModifiedIso: string | null;
};
export type GetChecklistMcTemplatesDocxDownloadApiArg = {
  filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
};
export type GetChecklistMcTemplatesDocxApiResponse = /** status 200 Successful response */ {
  collection: "checklistmctemplates";
  templates: {
    filename: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
    exists: boolean;
    contentType: string | null;
    sizeBytes: number | null;
    lastModifiedIso: string | null;
    etag: string | null;
  }[];
};
export type GetChecklistMcTemplatesDocxApiArg = void;
export type PostChecklistGenerateDocxAzureApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostChecklistGenerateDocxAzureApiArg = {
  body: {
    data?: any;
    templateName: "checklist_1col.docx" | "checklist_2col.docx" | "checklist_3col.docx";
    outputName?: string;
  };
};
export type PostChecklistIntegrationGenerateApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostChecklistIntegrationGenerateApiArg = {
  body: {
    checklistId: number;
    signedBy: string;
  };
};
export type GetChecklistsByReviewByReviewIdApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  status: "ACTIVE" | "IN_DEVELOPMENT" | "DELIVERED" | "REMOVED" | "INACTIVE";
  checklistNrId: number;
  doksam?: {
    dkApproval?: {
      userId?: string;
      name: string | null;
      upn: string | null;
      approvedAt?: string | null;
    };
  };
}[];
export type GetChecklistsByReviewByReviewIdApiArg = {
  reviewId: string;
};
export type PutChecklistsByChecklistIdDkApprovalToggleApiResponse = /** status 200 Successful response */ {
  checklistId: string;
  approvedAt: string | null;
};
export type PutChecklistsByChecklistIdDkApprovalToggleApiArg = {
  checklistId: string;
  body: {
    isApproved: boolean;
  };
};
export type PostProjectByProjectIdIssuesCreateApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssuesCreateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    title: string;
    description?: string;
    connectedBimSpace?: {
      spaceDbId?: any;
      globalId?: string;
      roomNumber: string;
      roomName?: string;
      floor?: string;
      building?: string;
      ifcFile?: string;
    };
  };
};
export type GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiResponse = /** status 200 Successful response */ {
  children: {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
  parents: {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  }[];
};
export type GetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesApiArg = {
  projectId: string;
  _id: string;
};
export type PutProjectByProjectIdIssuesUpdateGantActivityApiResponse = /** status 200 Successful response */ {
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssuesUpdateGantActivityApiArg = {
  projectId: string;
  body: {
    issueId: string;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color?: string;
    }[];
  };
};
export type PutIssueConnectApiResponse = /** status 200 Successful response */ {
  source: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
  target: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutIssueConnectApiArg = {
  body: {
    projectId: string | any;
    issueBoardId: string | any;
    sourceIssueId: string | any;
    targetIssueId: string | any;
    action: "CONNECT" | "DISCONNECT";
  };
};
export type GetIssueByUserApiResponse = /** status 200 Successful response */ {
  _id: string;
  id: number;
  title: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  issueBoard: {
    _id: string;
    name: string;
  };
  project: {
    _id: string;
    maconomy: {
      name?: string | null;
    };
  };
}[];
export type GetIssueByUserApiArg = {
  relation: "assignedTo" | "owner" | "itemMembers";
  maxAgeYears?: number;
  projectId?: string;
};
export type PutProjectByProjectIdIssuesKanbanreorderApiResponse = /** status 200 Successful response */ {
  moved: {
    id: string;
    column: string;
    index: number;
  };
  changed: {
    id: string;
    index: number;
  }[];
  version: string;
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssuesKanbanreorderApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    issueId: string;
    boardId: string;
    attributeChanged: "status" | "bucket" | "tidsfrist";
    sourceColumn: string;
    targetColumn: string;
    targetPosition?: number;
  };
};
export type GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiResponse =
  /** status 200 Successful response */ {
    _id: string;
    id: number;
    title: string | null;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    issueBoard: {
      _id: string;
      name: string;
    };
  }[];
export type GetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsApiArg = {
  projectId: string;
  issueId: string;
};
export type PostProjectByProjectIdIssuesCopyApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssuesCopyApiArg = {
  projectId: string;
  body: {
    issueId: string;
    includeTasks?: boolean;
  };
};
export type GetProjectByProjectIdIssuesGetSingleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type GetProjectByProjectIdIssuesGetSingleApiArg = {
  projectId: string;
  issueId: string;
};
export type GetProjectByProjectIdIssuesExternalApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdIssuesExternalApiArg = {
  projectId: string;
  issueboardId: string;
  includeTasks?: "true" | "false";
};
export type GetProjectByProjectIdIssuesOnBoardApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdIssuesOnBoardApiArg = {
  projectId: string;
  issueboardId: string;
  includeIssues?: "true" | "false";
  includeTasks?: "true" | "false";
  taskOrIssue?: "ISSUE" | "TASK";
};
export type PostProjectByProjectIdIssuesOnBoardsApiResponse = /** status 200 Successful response */ {
  items: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  }[];
  totalCount?: number;
  boardCounts: {
    issueboardId: string;
    count: number;
  }[];
};
export type PostProjectByProjectIdIssuesOnBoardsApiArg = {
  projectId: string;
  body: {
    issueboardIds: string[];
    includeIssues?: "true" | "false";
    includeTasks?: "true" | "false";
    limit?: number;
    page?: number;
    includeTotalCount?: "true" | "false";
    filter?: {
      taskOrIssue?: "ISSUE" | "TASK";
      freeText?: string;
      issueboardIds?: string[];
      status?: string[];
      assignedToIds?: string[];
    };
    sort?: {
      field: "issueBoard.name" | "id" | "title" | "status" | "assignedTo" | "dates.due" | "pns";
      direction: "asc" | "desc";
    };
  };
};
export type PutProjectByProjectIdIssueUpdateDatesApiResponse = /** status 200 Successful response */ {
  updatedIssue: {
    _id: string;
    createdAt: string;
    project?: any;
    taskOrIssue: "ISSUE" | "TASK";
    typeOfIssue: string | null;
    id: number;
    title: string | null;
    pns: string | null;
    description: string | null;
    conclusion: string | null;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    tags: string[];
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    priority: "HIGH" | "MEDIUM" | "LOW";
    clientAccess: boolean;
    gis?: {
      gisPoint?: {
        x?: number;
        y?: number;
        z?: number;
        wkid?: number;
      } | null;
      gisCamera?: {
        position?: {
          spatialReference?: {
            latestWkid?: number;
            wkid?: number;
          } | null;
          x?: number;
          y?: number;
          z?: number;
        } | null;
        heading?: number;
        tilt?: number;
      } | null;
    } | null;
    todos: {
      _id: string;
      text: string;
      createdAt: string;
      listIndex: number;
      completedDate?: string | null;
      createdByName: string;
      completedBy?: string | null;
      updatedBy?: string | null;
      createdBy?: string | null;
      completedByName?: string | null;
    }[];
    bucket: string;
    hours?: {
      orignalEstimate?: number | null;
      remaining?: number | null;
      completed?: number | null;
    };
    archived: boolean;
    kanbanOrder?: {
      status?: number;
      bucket?: number;
      tidsfrist?: number;
    } | null;
    connectedMeetingAgendas: any[] | null;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId: string;
      roomNumber: string;
      roomName: string;
      floor: string;
      building: string;
      ifcFile: string;
    }[];
    otherAttributesData?: {
      [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
    } | null;
    showTodosInKanban: boolean;
    risiko?: {
      probability?: string | null;
      consequence?: {
        [key: string]: string | null;
      } | null;
      categoryComment?: string | null;
    };
    noteboardNode?: {
      visible?: boolean | null;
      x?: number | null;
      y?: number | null;
    } | null;
    gantActivities: {
      start?: string;
      end?: string;
      title: string;
      description: string;
      progress: number;
      color: string;
    }[];
    updatedAt?: string | null;
    connections?: {
      common: {
        children: string[];
        parents: string[];
      };
    } | null;
    referenceUrl: string;
    lastUpdatedBy?: {
      _id: string;
      name: string;
    } | null;
    owner?: {
      _id: string;
      name: string;
    } | null;
    createdBy?: {
      _id: string;
      name: string;
    } | null;
    assignedTo?: {
      _id: string;
      name: string;
    } | null;
    itemMembers: ({
      _id: string;
      name: string;
    } | null)[];
    connectedIssue?: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    } | null;
    connectedTasks: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
    }[];
    connectedTasksAndIssuesFromOtherBoards: {
      _id: string;
      title: string | null;
      id: number;
      project?: any;
      archived: boolean;
      status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
        completed?: string | null;
      } | null;
      issueBoard: string;
    }[];
    connectedChecklistItems: any[];
    subscribers: any[];
    comments: {
      _id: string;
      createdBy: string;
      text: string;
      createdDate: string;
      createdByName: string;
      deleted: boolean;
      plainText?: string;
    }[];
    issueBoard: {
      _id: string;
      name: string;
    };
  };
};
export type PutProjectByProjectIdIssueUpdateDatesApiArg = {
  projectId: string;
  body: {
    issueId: string;
    dates: {
      plannedStart: string;
      due: string;
    };
  };
};
export type PutProjectByProjectIdIssueConnectedBimSpacesApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueConnectedBimSpacesApiArg = {
  projectId: string;
  body: {
    issueId: string;
    connectedBimSpaces: {
      spaceDbId?: any;
      globalId?: string;
      roomNumber: string;
      roomName?: string;
      floor?: string;
      building?: string;
      ifcFile?: string;
    }[];
  };
};
export type GetProjectByProjectIdConnectedTasksApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
}[];
export type GetProjectByProjectIdConnectedTasksApiArg = {
  projectId: string;
  issueId: string;
};
export type PostProjectByProjectIdIssueTodosAddApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PostProjectByProjectIdIssueTodosAddApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoText: string;
  };
};
export type PutProjectByProjectIdIssueTodosUpdateApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueTodosUpdateApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoId: string;
    text: string;
  };
};
export type PutProjectByProjectIdIssueTodosToggleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueTodosToggleApiArg = {
  projectId: string;
  body: {
    issueId: string;
    todoId: string;
    isChecked: boolean;
  };
};
export type DeleteProjectByProjectIdIssueTodosDeleteApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type DeleteProjectByProjectIdIssueTodosDeleteApiArg = {
  projectId: string;
  issueId: string;
  todoId: string;
};
export type PostProjectByProjectIdIssuesGenerateDocxApiResponse = /** status 200 Successful response */ {
  filename: string;
  mime: string;
  base64: string;
};
export type PostProjectByProjectIdIssuesGenerateDocxApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    templateBlobName: string;
    issueIds: string[];
  };
};
export type PutProjectByProjectIdIssueUpdateSimpleApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateSimpleApiArg = {
  projectId: string;
  body: {
    _id: string;
    property: {
      title?: string | null;
      status?: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
      priority?: "HIGH" | "MEDIUM" | "LOW";
      referenceUrl?: string;
      bucket?: string;
      typeOfIssue?: string | null;
      pns?: string | null;
      description?: string | null;
      conclusion?: string | null;
      tags?: string[];
      showTodosInKanban?: boolean;
      otherAttributesData?: {
        [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
      } | null;
      risiko?: {
        probability?: string | null;
        consequence?: {
          [key: string]: string | null;
        } | null;
        categoryComment?: string | null;
      };
      hours?: {
        orignalEstimate?: number | null;
        remaining?: number | null;
        completed?: number | null;
      };
      dates?: {
        plannedStart?: string | null;
        due?: string | null;
      } | null;
      gantActivities?: {
        start?: string;
        end?: string;
        title?: string;
        description?: string;
        progress?: number;
        color?: string;
      }[];
    };
  };
};
export type PutProjectByProjectIdIssueUpdateUserApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueUpdateUserApiArg = {
  projectId: string;
  body: {
    _id: string;
    property: {
      assignedTo?: {
        _id: string | any;
        name: string;
      } | null;
      itemMembers?: {
        _id: string | any;
        name: string;
      }[];
      owner?: {
        _id: string | any;
        name: string;
      } | null;
    };
  };
};
export type PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueConnectedTasksUpdateOrderApiArg = {
  projectId: string;
  body: {
    issueId: string;
    newOrder: string[];
  };
};
export type PutProjectByProjectIdIssueSubscribeApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueSubscribeApiArg = {
  projectId: string;
  body: {
    issueId: string;
  };
};
export type PutProjectByProjectIdIssueArchiveApiResponse = /** status 200 Successful response */ {
  _id: string;
  createdAt: string;
  project?: any;
  taskOrIssue: "ISSUE" | "TASK";
  typeOfIssue: string | null;
  id: number;
  title: string | null;
  pns: string | null;
  description: string | null;
  conclusion: string | null;
  dates?: {
    plannedStart?: string | null;
    due?: string | null;
    completed?: string | null;
  } | null;
  tags: string[];
  status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
  priority: "HIGH" | "MEDIUM" | "LOW";
  clientAccess: boolean;
  gis?: {
    gisPoint?: {
      x?: number;
      y?: number;
      z?: number;
      wkid?: number;
    } | null;
    gisCamera?: {
      position?: {
        spatialReference?: {
          latestWkid?: number;
          wkid?: number;
        } | null;
        x?: number;
        y?: number;
        z?: number;
      } | null;
      heading?: number;
      tilt?: number;
    } | null;
  } | null;
  todos: {
    _id: string;
    text: string;
    createdAt: string;
    listIndex: number;
    completedDate?: string | null;
    createdByName: string;
    completedBy?: string | null;
    updatedBy?: string | null;
    createdBy?: string | null;
    completedByName?: string | null;
  }[];
  bucket: string;
  hours?: {
    orignalEstimate?: number | null;
    remaining?: number | null;
    completed?: number | null;
  };
  archived: boolean;
  kanbanOrder?: {
    status?: number;
    bucket?: number;
    tidsfrist?: number;
  } | null;
  connectedMeetingAgendas: any[] | null;
  connectedBimSpaces: {
    spaceDbId?: any;
    globalId: string;
    roomNumber: string;
    roomName: string;
    floor: string;
    building: string;
    ifcFile: string;
  }[];
  otherAttributesData?: {
    [key: string]: (string | number | boolean | null) | (string | number | boolean | null)[];
  } | null;
  showTodosInKanban: boolean;
  risiko?: {
    probability?: string | null;
    consequence?: {
      [key: string]: string | null;
    } | null;
    categoryComment?: string | null;
  };
  noteboardNode?: {
    visible?: boolean | null;
    x?: number | null;
    y?: number | null;
  } | null;
  gantActivities: {
    start?: string;
    end?: string;
    title: string;
    description: string;
    progress: number;
    color: string;
  }[];
  updatedAt?: string | null;
  connections?: {
    common: {
      children: string[];
      parents: string[];
    };
  } | null;
  referenceUrl: string;
  lastUpdatedBy?: {
    _id: string;
    name: string;
  } | null;
  owner?: {
    _id: string;
    name: string;
  } | null;
  createdBy?: {
    _id: string;
    name: string;
  } | null;
  assignedTo?: {
    _id: string;
    name: string;
  } | null;
  itemMembers: ({
    _id: string;
    name: string;
  } | null)[];
  connectedIssue?: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  } | null;
  connectedTasks: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
  }[];
  connectedTasksAndIssuesFromOtherBoards: {
    _id: string;
    title: string | null;
    id: number;
    project?: any;
    archived: boolean;
    status: "Fullf\u00F8rt" | "I prosess" | "P\u00E5 hold" | "Opprettet" | "Utg\u00E5r";
    dates?: {
      plannedStart?: string | null;
      due?: string | null;
      completed?: string | null;
    } | null;
    issueBoard: string;
  }[];
  connectedChecklistItems: any[];
  subscribers: any[];
  comments: {
    _id: string;
    createdBy: string;
    text: string;
    createdDate: string;
    createdByName: string;
    deleted: boolean;
    plainText?: string;
  }[];
  issueBoard: {
    _id: string;
    name: string;
  };
};
export type PutProjectByProjectIdIssueArchiveApiArg = {
  projectId: string;
  body: {
    issueId: string;
  };
};
export type GetProjectByProjectIdIssueAndIssueIdLogsApiResponse = /** status 200 Successful response */ {
  _id: string;
  project: string;
  board: string;
  issueId: string;
  taskOrIssue: "ISSUE" | "TASK";
  column: string;
  oldValue?: string;
  newValue: string;
  userName: string;
  updatedAt: string;
  createdAt: string;
}[];
export type GetProjectByProjectIdIssueAndIssueIdLogsApiArg = {
  projectId: string;
  issueId: string;
};
export type GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiResponse =
  /** status 200 Successful response */ {
    id: number;
    data: {
      [key: string]: {
        typeInConf?:
          | (
              | "STRING"
              | "MULTILINESTRING"
              | "NUMBER"
              | "DATE"
              | "BOOLEAN"
              | "DROPDOWN"
              | "FORMULA"
              | "MATH_FORMULA"
              | null
            )
          | null;
        value?: any;
        isTypeValid: boolean;
      };
    };
  }[];
export type GetProjectByProjectIdIssuesValidateOtherAttributesByBoardApiArg = {
  projectId: string;
  issueBoardId: string;
};
export type PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiResponse = /** status 200 Successful response */ {
  status: "success";
  verdict: "PASS" | "PARTIAL" | "FAIL" | "UNCERTAIN";
  inputData: {
    otherAttributeIText: string;
    pdfFileCount: number;
    pdfFiles: {
      fileName: string;
      blobName: string;
      extractedTextLength: number;
    }[];
  };
  summary: string;
  analysis: string[];
  evidence: {
    documentName: string;
    page: number;
    text: string;
  }[];
  gaps: string[];
};
export type PostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckApiArg = {
  issueId: string;
  projectId: string;
  body: {
    body?: object;
  };
};
export type GetUsageAggregateProjectStartsApiResponse = /** status 200 Successful response */ {
  keyField?: number | string;
  count: number;
  projectName: string;
  projectId: string;
}[];
export type GetUsageAggregateProjectStartsApiArg = {
  fromDate?: string | null;
  toDate?: string | null;
  appName?: string;
};
export type GetUsageAggregateProjectApiResponse = /** status 200 Successful response */ {
  users: {
    name: string;
    count: number;
  }[];
  appStarts: {
    name: string;
    count: number;
  }[];
};
export type GetUsageAggregateProjectApiArg = {
  fromDate?: string | null;
  toDate?: string | null;
  projectId: string;
};
export type GetProjectByProjectIdTableTemplatesApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
}[];
export type GetProjectByProjectIdTableTemplatesApiArg = {
  projectId: string;
  issueboardId: string;
};
export type PatchProjectByProjectIdTableTemplateApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
};
export type PatchProjectByProjectIdTableTemplateApiArg = {
  projectId: string;
  body: {
    tableTemplate: {
      _id: string | any;
      name: string;
      issueBoard: string | any;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    };
  };
};
export type PostProjectByProjectIdTableTemplateApiResponse = /** status 200 Successful response */ {
  _id: string;
  name: string;
  issueBoard: string;
  tableColumns: string[];
  tableColConfigs?: {
    colId?: string;
    orderPriority?: number;
    width?: number;
  }[];
  taskAndOrIssue?: ("TASK" | "ISSUE")[];
  filters: {
    typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
    dataField?: string;
    multiFilterValues?: string[] | object[];
    isActive?: boolean;
  }[];
  sortedCol?: {
    column?: string;
    direction?: "ASC" | "DESC";
  };
  archived?: boolean;
};
export type PostProjectByProjectIdTableTemplateApiArg = {
  projectId: string;
  body: {
    tableTemplate: {
      name: string;
      issueBoard: string | any;
      tableColumns: string[];
      tableColConfigs?: {
        colId?: string;
        orderPriority?: number;
        width?: number;
      }[];
      taskAndOrIssue?: ("TASK" | "ISSUE")[];
      filters: {
        typeOfFilter?: "MULTIFILTER" | "BOOLEANFILTER";
        dataField?: string;
        multiFilterValues?: string[] | object[];
        isActive?: boolean;
      }[];
      sortedCol?: {
        column?: string;
        direction?: "ASC" | "DESC";
      };
      archived?: boolean;
    };
  };
};
export type PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiResponse = /** status 200 Successful response */ {
  agendaItem?: any;
};
export type PutProjectByProjectIdAgendaItemReorderConnectedIssuesApiArg = {
  projectId: string;
  body: {
    agendaItemId: string;
    newOrder: string[];
  };
};
export type PostIssueboardFavoriteToggleApiResponse = /** status 200 Successful response */ {
  isFavorite: boolean;
};
export type PostIssueboardFavoriteToggleApiArg = {
  body: {
    projectId: string;
    issueboardId: string;
  };
};
export type GetIssueboardFavoritesApiResponse = /** status 200 Successful response */ {
  _id: string;
  user: string;
  issueboard: string;
  project: string;
}[];
export type GetIssueboardFavoritesApiArg = {
  projectId: string;
};
export type PutProjectByProjectIdGanttVacationsApiResponse = /** status 200 Successful response */ {
  success: boolean;
};
export type PutProjectByProjectIdGanttVacationsApiArg = {
  projectId: string;
  body: {
    issueboardId: string;
    ganttVacationSettings: {
      startDate: string;
      endDate: string;
      title: string;
    }[];
  };
};
export type PatchBoardsTemplateActionApiResponse = /** status 200 Successful response */ {
  boardId: string;
  template: {
    isTemplate: boolean;
    description: string;
    admin?: {
      _id: string;
      name: string;
    };
    status: "CREATED" | "SET_TO_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
    approvedBy?: {
      _id: string;
      name: string;
    };
    approvalDate?: string;
    history: {
      action: "CREATED" | "SET_TO_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
      by: {
        _id: string;
        name: string;
      };
      date: string;
      comment: string;
    }[];
  };
};
export type PatchBoardsTemplateActionApiArg = {
  body: {
    boardId: string;
    action: "CREATED" | "SET_TO_REVIEW" | "APPROVED" | "REJECTED" | "UPDATED";
    comment?: string;
  };
};
export type PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiResponse = /** status 200 Successful response */ {
  success: true;
  issueBoardId: string;
  tags: {
    _id?: string;
    title: string;
  }[];
};
export type PostProjectByProjectIdIssueboardPredefinedtagsUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    tags: {
      _id?: string | any;
      title: string;
    }[];
  };
};
export type PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiResponse = /** status 200 Successful response */ {
  success: true;
  issueBoardId: string;
  usePredefinedTags?: boolean;
  useOnlyPredefinedTags?: boolean;
};
export type PostProjectByProjectIdIssueboardUsepredefinedtagsUpdateApiArg = {
  projectId: string;
  body: {
    issueBoardId: string;
    useCustomTags: boolean;
  };
};
export type GetProjectByProjectIdIssueLogsApiResponse = /** status 200 Successful response */ {
  items: {
    _id: string;
    project: string;
    board: string;
    issueId: string;
    taskOrIssue: "ISSUE" | "TASK";
    column: string;
    oldValue?: string;
    newValue: string;
    userName: string;
    updatedAt: string;
    createdAt: string;
  }[];
  totalCount?: number;
};
export type GetProjectByProjectIdIssueLogsApiArg = {
  projectId: string;
  boardId: string;
  createdAtFrom?: string;
  createdAtTo?: string;
  limit?: number;
  page?: number;
  includeTotalCount?: "true" | "false";
};
export type GetMcbimFurnitureAndWallsOnFloorApiResponse = /** status 200 Successful response */ {
  _id: string;
  name?: string;
  longName?: string;
  instanceClass: "IfcFurniture" | "IfcWall" | "IfcWallStandardCase";
  bbox?: number[][];
}[];
export type GetMcbimFurnitureAndWallsOnFloorApiArg = {
  projectNo: number;
  floorName: string;
};
export type GetMcbimSpacesApiResponse = /** status 200 Successful response */ {
  spaceDbId?: any;
  globalId: string;
  roomNumber: string;
  roomName: string;
  floor: string;
  building: string;
  ifcFile: string;
}[];
export type GetMcbimSpacesApiArg = {
  projectNo: number;
};
export type GetMcbimSpacesOnFloorApiResponse = /** status 200 Successful response */ {
  _id: string;
  name?: string;
  longName?: string;
  polygon?: number[][];
}[];
export type GetMcbimSpacesOnFloorApiArg = {
  projectNo: number;
  floorName: string;
};
export type GetEmailsTemplatesApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templates: {
    templateKey:
      | "landing-page-inquiry"
      | "meeting-agenda"
      | "project-invite"
      | "reset-password"
      | "task-notify"
      | "test-mail";
    files: {
      filename:
        | "html.hbs"
        | "html.hbs.json"
        | "html.handlebars.json"
        | "styles.css"
        | "subject.html"
        | "subject.pug"
        | "text.pug"
        | "html.pug";
      exists: boolean;
      contentType: string | null;
      sizeBytes: number | null;
      lastModifiedIso: string | null;
      etag: string | null;
    }[];
    allRequiredFilesExist: boolean;
  }[];
};
export type GetEmailsTemplatesApiArg = void;
export type GetEmailsTemplatesDownloadApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templateKey:
    | "landing-page-inquiry"
    | "meeting-agenda"
    | "project-invite"
    | "reset-password"
    | "task-notify"
    | "test-mail";
  contentType: "application/zip";
  filename: string;
  base64: string;
  sizeBytes: number;
  etag: string | null;
  lastModifiedIso: string | null;
};
export type GetEmailsTemplatesDownloadApiArg = {
  templateKey:
    | "landing-page-inquiry"
    | "meeting-agenda"
    | "project-invite"
    | "reset-password"
    | "task-notify"
    | "test-mail";
};
export type PostEmailsTemplatesUploadZipApiResponse = /** status 200 Successful response */ {
  collection: "emails";
  templateKey:
    | "landing-page-inquiry"
    | "meeting-agenda"
    | "project-invite"
    | "reset-password"
    | "task-notify"
    | "test-mail";
  uploaded: {
    filename:
      | "html.hbs"
      | "html.hbs.json"
      | "html.handlebars.json"
      | "styles.css"
      | "subject.html"
      | "subject.pug"
      | "text.pug"
      | "html.pug";
    blobName: string;
    etag?: string;
    sizeBytes: number;
  }[];
};
export type PostEmailsTemplatesUploadZipApiArg = {
  body: {
    templateKey:
      | "landing-page-inquiry"
      | "meeting-agenda"
      | "project-invite"
      | "reset-password"
      | "task-notify"
      | "test-mail";
    file: {
      filename: string;
      contentType: "application/zip";
      base64: string;
    };
  };
};
export type GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
}[];
export type GetProjectByProjectIdProjectdashboardAndDashboardIdNewsApiArg = {
  projectId: string;
  dashboardId: string;
};
export type PostProjectByProjectIdProjectdashboardNewsApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
};
export type PostProjectByProjectIdProjectdashboardNewsApiArg = {
  projectId: string;
  body: {
    newsItem: {
      dashboardId: string;
      text: string;
      deleted?: boolean;
      metadata?: {
        plainText?: string;
        mentionIdArray?: (string | any)[];
      };
    };
  };
};
export type PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
};
export type PutProjectByProjectIdProjectdashboardNewsAndNewsItemIdApiArg = {
  projectId: string;
  newsItemId: string;
  body: {
    newsItem: {
      dashboard: string;
      text?: string;
      deleted?: boolean;
      metadata?: {
        plainText?: string;
        mentionIdArray?: (string | any)[];
      };
    };
  };
};
export type PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiResponse =
  /** status 200 Successful response */ {
    _id?: any;
    dashboard?: any;
    project?: any;
    text: string;
    deleted: boolean;
    createdBy?: any;
    createdByUser: {
      _id: string;
      name: string;
    };
    createdAt: string;
    reactions?: {
      user: {
        _id: string;
        name: string;
      };
      date: string;
      emoji: string;
    }[];
  };
export type PostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionApiArg = {
  projectId: string;
  dashboardId: string;
  body: {
    commentId: string;
    emoji: string;
  };
};
export type PostProjectByProjectIdProjectdashboardNewsSearchApiResponse = /** status 200 Successful response */ {
  _id?: any;
  dashboard?: any;
  project?: any;
  text: string;
  deleted: boolean;
  createdBy?: any;
  createdByUser: {
    _id: string;
    name: string;
  };
  createdAt: string;
  reactions?: {
    user: {
      _id: string;
      name: string;
    };
    date: string;
    emoji: string;
  }[];
}[];
export type PostProjectByProjectIdProjectdashboardNewsSearchApiArg = {
  projectId: string;
  body: {
    dashboardId: string;
    query: string;
    users: string[];
  };
};
export type AuthorizationNotProvidedError401 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InsufficientAccessError403 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InternalServerErrorError500 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type InvalidInputDataError400 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export type NotFoundError404 = {
  /** The error message */
  message: string;
  /** The error code */
  code: string;
  /** An array of issues that were responsible for the error */
  issues?: {
    message: string;
  }[];
};
export const {
  usePingQuery,
  useGetProjectMembersQuery,
  usePutProjectMemberMutation,
  useGetProjectMemberQuery,
  usePutProjectMemberOtherAttributesMutation,
  useGetProjectIssueboardsQuery,
  useGetProjectPnsQuery,
  useGetProjectProjectIdQuery,
  useGetProjectsMcappsQuery,
  useGetProjectsMaconomyQuery,
  usePostProjectByProjectIdReportboardsMutation,
  usePutUserProfileMutation,
  useGetWhoamiQuery,
  usePostUserApikeyMutation,
  useGetUserApikeyQuery,
  useDeleteUserApikeyMutation,
  useGetChecklistMcTemplatesQuery,
  usePostChecklistMcTemplatesMutation,
  usePostChecklistGenerateDocxMutation,
  useGetChecklistByChecklistIdExportQuery,
  usePostChecklistValidateExcelMutation,
  usePostChecklistMcTemplatesPublishMutation,
  useGetChecklistLogsQuery,
  useGetChecklistProjectTemplatesQuery,
  usePostChecklistMcTemplatesUploadDocxMutation,
  useGetChecklistMcTemplatesDocxDownloadQuery,
  useGetChecklistMcTemplatesDocxQuery,
  usePostChecklistGenerateDocxAzureMutation,
  usePostChecklistIntegrationGenerateMutation,
  useGetChecklistsByReviewByReviewIdQuery,
  usePutChecklistsByChecklistIdDkApprovalToggleMutation,
  usePostProjectByProjectIdIssuesCreateMutation,
  useGetProjectByProjectIdIssuesTrpcIssueGetConnectedIssuesQuery,
  usePutProjectByProjectIdIssuesUpdateGantActivityMutation,
  usePutIssueConnectMutation,
  useGetIssueByUserQuery,
  usePutProjectByProjectIdIssuesKanbanreorderMutation,
  useGetProjectByProjectIdIssuesByConnectedTasksAndIssuesFromOtherBoardsQuery,
  usePostProjectByProjectIdIssuesCopyMutation,
  useGetProjectByProjectIdIssuesGetSingleQuery,
  useGetProjectByProjectIdIssuesExternalQuery,
  useGetProjectByProjectIdIssuesOnBoardQuery,
  usePostProjectByProjectIdIssuesOnBoardsMutation,
  usePutProjectByProjectIdIssueUpdateDatesMutation,
  usePutProjectByProjectIdIssueConnectedBimSpacesMutation,
  useGetProjectByProjectIdConnectedTasksQuery,
  usePostProjectByProjectIdIssueTodosAddMutation,
  usePutProjectByProjectIdIssueTodosUpdateMutation,
  usePutProjectByProjectIdIssueTodosToggleMutation,
  useDeleteProjectByProjectIdIssueTodosDeleteMutation,
  usePostProjectByProjectIdIssuesGenerateDocxMutation,
  usePutProjectByProjectIdIssueUpdateSimpleMutation,
  usePutProjectByProjectIdIssueUpdateUserMutation,
  usePutProjectByProjectIdIssueConnectedTasksUpdateOrderMutation,
  usePutProjectByProjectIdIssueSubscribeMutation,
  usePutProjectByProjectIdIssueArchiveMutation,
  useGetProjectByProjectIdIssueAndIssueIdLogsQuery,
  useGetProjectByProjectIdIssuesValidateOtherAttributesByBoardQuery,
  usePostProjectByProjectIdIssuesAndIssueIdRunBreeamCheckMutation,
  useGetUsageAggregateProjectStartsQuery,
  useGetUsageAggregateProjectQuery,
  useGetProjectByProjectIdTableTemplatesQuery,
  usePatchProjectByProjectIdTableTemplateMutation,
  usePostProjectByProjectIdTableTemplateMutation,
  usePutProjectByProjectIdAgendaItemReorderConnectedIssuesMutation,
  usePostIssueboardFavoriteToggleMutation,
  useGetIssueboardFavoritesQuery,
  usePutProjectByProjectIdGanttVacationsMutation,
  usePatchBoardsTemplateActionMutation,
  usePostProjectByProjectIdIssueboardPredefinedtagsUpdateMutation,
  usePostProjectByProjectIdIssueboardUsepredefinedtagsUpdateMutation,
  useGetProjectByProjectIdIssueLogsQuery,
  useGetMcbimFurnitureAndWallsOnFloorQuery,
  useGetMcbimSpacesQuery,
  useGetMcbimSpacesOnFloorQuery,
  useGetEmailsTemplatesQuery,
  useGetEmailsTemplatesDownloadQuery,
  usePostEmailsTemplatesUploadZipMutation,
  useGetProjectByProjectIdProjectdashboardAndDashboardIdNewsQuery,
  usePostProjectByProjectIdProjectdashboardNewsMutation,
  usePutProjectByProjectIdProjectdashboardNewsAndNewsItemIdMutation,
  usePostProjectByProjectIdProjectdashboardAndDashboardIdNewsCommentReactionMutation,
  usePostProjectByProjectIdProjectdashboardNewsSearchMutation,
} = injectedRtkApi;
